/**
 * Created by zhangyanbo on 2016/12/30.
 */
import Vue from 'vue';
import tpl from './tpl.html';
import commonService from '../../../common/commonService';
import Loading from '../../../component/Loading.vue';
import ParseUrl from '../../../util/parseUrl';
import Pager from '../../../component/Pager.vue';
import NoData from '../../../component/NoData.vue';


export default Vue.extend({
    name: "blockInfo",
    template: tpl,
    components: {
        Loading,
        Pager,
        NoData
    },
    data(){
        return {
            trade:{
                from_acct:'',//发起方
                from_addr:'',//发起方
                transaction_type:'', //交易类型
                time:'',//确认时间
                fee:'', //手续费
                func_name:'',//合约调用函数名
                to_acct:'',//接收方
                to_addr:'',//交易地址
                amount:'',//交易金额
                block_num:'',//区块高度
                remark:'',//备注
                func_arg:''//调用参数
            },
            tradeList:[],
            condition: {
                pageNo: 1,
                pageSize: 10
            },
            isLoading:false,
            pageNum: 0,
            param_hash:'',
            tempTransactionId:'',
            isShowContract:false,
            contractList:{}
        }
    },
    created() {
        this.getUrlParam();
    },
    mounted(){
        window.scrollTo(0,0);
    },
    methods: {
        /*
         * 获取地址栏中参数
         *
         * */
        getUrlParam(){
            if(localStorage.TradePageNo) {
                this.condition.pageNo = localStorage.TradePageNo;
            }
            let tempParam = ParseUrl();
            this.param_hash = tempParam.tradeId;
            this.fetchTradeInfo();
        },

        /*
         * 通过区块hash显示查找交易信息
         *
         * */
        fetchTradeInfo() {
            let param = {
                'trx_id':this.param_hash
            }
            commonService.tradeInfo(param).done((rep) => {
                    let tempTrade = rep.result.data[0];
                    this.tradeList = rep.result.data[0];

                    if(tempTrade.trx_type=='0') {
                        this.tradeList.trx_type = '普通转账';
                    }else if(tempTrade.trx_type=='1') {
                        this.tradeList.trx_type = '代理领工资';
                    }else if(tempTrade.trx_type=='2') {
                        this.tradeList.trx_type = '账户注册';
                    }else if(tempTrade.trx_type=='3') {
                        this.tradeList.trx_type = '注册代理';
                    }else if(tempTrade.trx_type=='4') {
                        this.tradeList.trx_type = '升级代理';
                    }else if(tempTrade.trx_type=='5') {
                        this.tradeList.trx_type = '更新账户';
                    }
                    else if(tempTrade.trx_type=='10') {
                        this.tradeList.trx_type = '合约注册';
                    }else if(tempTrade.trx_type=='11') {
                        this.tradeList.trx_type = '合约充值';

                        this.tempTransactionId = tempTrade.trx_id;
                        this.fetchTransactionExInfo();
                    }else if(tempTrade.trx_type=='12') {
                        this.tradeList.trx_type = '合约升级';

                        this.tempTransactionId = tempTrade.trx_id;
                        this.fetchTransactionExInfo();

                    }else if(tempTrade.trx_type=='13') {
                        this.tradeList.trx_type = '合约销毁';

                        this.tempTransactionId = tempTrade.trx_id;
                        this.fetchTransactionExInfo();

                    }else if(tempTrade.trx_type=='14') {
                        this.tradeList.trx_type = '合约调用';

                        this.tempTransactionId = tempTrade.trx_id;
                        this.fetchTransactionExInfo();

                    }else if(tempTrade.trx_type=='15') {
                        this.tradeList.trx_type = '合约出账';

                        this.tempTransactionId = tempTrade.trx_id;
                        this.fetchTransactionExInfo();

                    }

            }).fail((rep) => {
                window.error("网络异常，请稍后再试");
            }).always(()=>{

            });
        },

        /*
        *
        *合约出账信息展示
        * */
        fetchTransactionExInfo() {
            this.isLoading = true;
            let param = {
                'orig_trx_id':this.tempTransactionId,
                'page':+this.condition.pageNo,
                'per_page':this.condition.pageSize
                // 'orig_trx_id':'b75084b1eaaf14898ec8ff74fe57bda438328192'
            }
            commonService.transactionExInfo(param).done((rep) => {
                this.pageNum = Math.ceil(rep.result.total/this.condition.pageSize);
                if(rep.result.data.length) {
                    this.isShowContract = true;
                    this.contractList = rep.result.data;
                }
            }).fail((rep) => {
                this.isShowContract = false;
                window.error("网络异常，请稍后再试");

            }).always(()=>{
                this.isLoading = false;
            });
        },
        /**
         * 分页
         * @param pageNo
         */
        changePage(pageNo) {
            localStorage.TradePageNo = +pageNo;
            this.condition.pageNo = pageNo;
            this.fetchTransactionExInfo();
        }
    }
});



// WEBPACK FOOTER //
// ./src/module/index/tradeInfo/main.js